import { bool, number } from 'prop-types';
import React, { useEffect } from 'react';

// RevealJS
import Reveal from 'reveal.js';
import HL from 'reveal.js/plugin/highlight/highlight';
import MD from 'reveal.js/plugin/markdown/markdown';
import RevealNotes from 'reveal.js/plugin/notes/notes';

import Home from './Home';
import LockedModule from './LockedModule';
import { MODULE_CONFIG, MODULE_VISIBILITY } from './config/modules';
import Part1 from './part-1/Part';
import Part2 from './part-2/Part';
import Part3 from './part-3/Part';
import Part4 from './part-4/Part';
import Part5 from './part-5/Part';

function App(props) {
  const {
    width,
    height,
    margin,
    controls,
    slideNumber,
    history,
    mouseWheel
  } = props;

  useEffect(() => {
    Reveal.initialize({
      width,
      height,
      margin,
      controls,
      slideNumber,
      history,
      mouseWheel,
      transition: 'slide',
      fragmentInURL: false,
      backgroundTransition: 'zoom',
      navigationMode: 'linear',
      // keyboard: {
      //   38: 'next',
      //   40: 'prev'
      // },
      plugins: [HL, MD, RevealNotes]
    }).then(() => {
      try {
        const slideNumber = document.getElementsByClassName('slide-number')[0];
        slideNumber.addEventListener('click', () => Reveal.toggleOverview());
      } catch (e) {
        console.log(e);
      }
    });
  }, [width, height, margin, controls, slideNumber, history, mouseWheel]);

  return (
    <div className="reveal">
      <div className="slides">
        <section
          id="home"
          data-background="linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%)"
          style={{ margin: 0, padding: 0 }}>
          <Home />
        </section>
        {MODULE_VISIBILITY['part-1'] ? (
          <Part1 />
        ) : (
          <section id="part-1">
            <LockedModule moduleName={MODULE_CONFIG['part-1'].title} />
          </section>
        )}
        {MODULE_VISIBILITY['part-2'] ? (
          <Part2 />
        ) : (
          <section id="part-2">
            <LockedModule moduleName={MODULE_CONFIG['part-2'].title} />
          </section>
        )}
        {MODULE_VISIBILITY['part-3'] ? (
          <Part3 />
        ) : (
          <section id="part-3">
            <LockedModule moduleName={MODULE_CONFIG['part-3'].title} />
          </section>
        )}
        {MODULE_VISIBILITY['part-4'] ? (
          <Part4 />
        ) : (
          <section id="part-4">
            <LockedModule moduleName={MODULE_CONFIG['part-4'].title} />
          </section>
        )}
        {MODULE_VISIBILITY['part-5'] ? (
          <Part5 />
        ) : (
          <section id="part-5">
            <LockedModule moduleName={MODULE_CONFIG['part-5'].title} />
          </section>
        )}
      </div>
    </div>
  );
}

App.defaultProps = {
  width: 1280,
  height: 720,
  margin: 0.05,
  controls: false,
  slideNumber: false,
  history: false,
  mouseWheel: false
};

App.propTypes = {
  width: number,
  height: number,
  margin: number,
  controls: bool,
  slideNumber: bool,
  history: bool,
  mouseWheel: bool
};

export default App;
